export default class AuthenticatedUser {
  constructor(obj, accounts, role) {
    this.id = obj.id;
    this.username = obj.username;
    this.email = obj.email;
    this.superId = obj.superId;
    this.isArchived = obj.isArchived;
    this.forcePasswordReset = obj.forcePassword;
    this.accounts = accounts;
    this.role = role;
  }
}
